import images from './images';

const courses = [
  {
    title: 'Smoked Salmon',
    price: '$20',
    tags: 'Spicy | AU',
  },
  {
    title: 'Japanese Scallop',
    price: '$49',
    tags: 'Fresh | AU',
  },
  {
    title: 'Jumbo Clam',
    price: '$34',
    tags: 'Platter | FR',
  },
  {
    title: 'Yellow Tail',
    price: '$31',
    tags: 'Sautéed | CA',
  },
  {
    title: 'Snow Crab',
    price: '$26',
    tags: 'Seafood | IE',
  },
];

const cocktails = [
  {
    title: 'Aperol Sprtiz',
    price: '$20',
    tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',
  },
  {
    title: "Dark 'N' Stormy",
    price: '$16',
    tags: 'Dark rum | Ginger beer | Slice of lime',
  },
  {
    title: 'Irish Guniness',
    price: '$10',
    tags: 'Guiness | Citrus | Rum',
  },
  {
    title: 'Old Fashioned',
    price: '$31',
    tags: 'Bourbon | Brown sugar | Angostura Bitters',
  },
  {
    title: 'Daquiri',
    price: '$26',
    tags: 'Gin | Sweet Vermouth | Campari | Orange garnish',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Michelin Stars',
    subtitle: 'The most coveted and respected culinary award in Nigeria',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Gourmand',
    subtitle: 'Awarded based to the most loved restaurant, based on public vote.',
  },
  {
    imgUrl: images.award05,
    title: 'NRA Hospitality',
    subtitle: 'Awarded in honor of restaurants, chefs and food journalists.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Awarded to all of the Top 10 rated chefs in Nigeria.',
  },
];

export default { courses, cocktails, awards };
